import React, { FC } from 'react';
import { useRouteMatch } from 'react-router';

import * as paths from 'paths';
import * as Containers from './containers';

const PostController: FC = () => {
  const match = useRouteMatch();

  let main = null;

  switch (match.path) {
    case paths.postCreate:
      main = <Containers.PostCreate />;
      break;
    case paths.postEdit:
      main = <Containers.PostContentLoader />;
      break;
    default:
      throw new Error('Unhandled Post Route');
  }

  return main;
};

export default PostController;
